import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, ordersPickingActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersPickingActions);

export default slice.reducer;
